<!-- <button (click)="copyDefaultToCustom()">Personalizar</button>
<button (click)="applyDefaultStyles()">Aplicar estilos</button> -->
<div class="layer-style-row" *ngFor="let default_colors of master_default_colors.styles; index as i">
    <div class="color-selector-mode-title" (click)="hiddenColors[default_colors.title]=!hiddenColors[default_colors.title]">
        <span>{{default_colors.title}}</span>
        <button class="btn-transparent">
            <img [ngClass]="{'rotate-up':hiddenColors[default_colors.title]}" src="/assets/img/tools/angle-down.svg" alt="">
        </button>
    </div>
    <div class='layer-styles' [ngClass]="hiddenColors[default_colors.title] ? 'hidden' : ''">

            <div class='color-selector-mode' *ngIf="default_colors.styles.available && default_colors.styles.available.normal">
                <div class="color-selector-subtitle">
                    <span>AVAILABLE > NORMAL</span>
                </div>
                <div class="color-select-body">
                    <div class="color-selector-col">
                        <div class="color-selector-row" *ngIf="default_colors.styles.available.normal.none.fillStyle">
                            <div>
                                <span>fillStyle:</span>
                            </div>
                            <div>
                                <span class="color-icon me-2" [ngStyle]="{'background-color': default_colors.styles.available.normal.none.fillStyle}"></span>
                                <span>{{default_colors.styles.available.normal.none.fillStyle}}</span>
                            </div>
                        </div>
                        <div class="color-selector-row" *ngIf="default_colors.styles.available.normal.none.strokeStyle">
                            <div> 
                                <span>strokeStyle:</span>
                            </div>
                            <div>
                                <span class="color-icon me-2" [ngStyle]="{'background-color': default_colors.styles.available.normal.none.strokeStyle}"></span>
                                <span>{{default_colors.styles.available.normal.none.strokeStyle}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="color-selector-col">
                        <div class="color-selector-row" *ngIf="default_colors.styles.available.normal.none['fill-opacity']">
                            <div>    
                                <span>fill-opacity:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.available.normal.none['fill-opacity']}}</span>
                            </div>
                        </div>
                        <div class="color-selector-row" *ngIf="default_colors.styles.available.normal.none['stroke-opacity']">
                            <div>
                                <span>stroke-opacity:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.available.normal.none['stroke-opacity']}}</span>
                            </div>
                        </div>
                        <div class="color-selector-row" *ngIf="default_colors.styles.available.normal.none.lineWidth">
                            <div>
                                <span>lineWidth:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.available.normal.none.lineWidth}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class='color-selector-mode'  *ngIf="default_colors.styles.available && default_colors.styles.available.hover">
                <div class="color-selector-subtitle">
                    <span>AVAILABLE > HOVER</span>
                </div>
                <div class="color-select-body">
                    <div class="color-selector-col">
                        <div class="color-selector-row" *ngIf="default_colors.styles.available.hover.none.fillStyle">
                            <div>
                                <span>fillStyle:</span>
                            </div>
                            <div>
                                <span class="color-icon me-2" [ngStyle]="{'background-color': default_colors.styles.available.hover.none.fillStyle}"></span>
                                <span>{{default_colors.styles.available.hover.none.fillStyle}}</span>
                            </div>
                        </div>
 
                        <div class="color-selector-row" *ngIf="default_colors.styles.available.hover.none.strokeStyle">
                            <div> 
                                <span>strokeStyle:</span>
                            </div>
                            <div>
                                <span class="color-icon me-2" [ngStyle]="{'background-color': default_colors.styles.available.hover.none.strokeStyle}"></span>
                                <span>{{default_colors.styles.available.hover.none.strokeStyle}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="color-selector-col">
                        <div class="color-selector-row" *ngIf="default_colors.styles.available.hover.none['fill-opacity']">
                            <div>    
                                <span>fill-opacity:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.available.hover.none['fill-opacity']}}</span>
                            </div>
                        </div>
                        <div class="color-selector-row" *ngIf="default_colors.styles.available.hover.none['stroke-opacity']">
                            <div>
                                <span>stroke-opacity:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.available.hover.none['stroke-opacity']}}</span>
                            </div>
                        </div>
                        <div class="color-selector-row" *ngIf="default_colors.styles.available.hover.none.lineWidth">
                            <div>
                                <span>lineWidth:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.available.hover.none.lineWidth}}</span>
                            </div>
                        </div>
                    </div>
                </div>   
            </div>
            <div class='color-selector-mode' *ngIf="default_colors.styles.selected && default_colors.styles.selected.normal">
                <div class="color-selector-subtitle">
                    <span>SELECTED > NORMAL</span>
                </div>
                <div class="color-select-body">
                    <div class="color-selector-col">
                        <div class="color-selector-row" *ngIf="default_colors.styles.selected.normal.none.fillStyle">
                            <div>
                                <span>fillStyle:</span>
                            </div>
                            <div>
                                <span class="color-icon me-2" [ngStyle]="{'background-color': default_colors.styles.selected.normal.none.fillStyle}"></span>
                                <span>{{default_colors.styles.selected.normal.none.fillStyle}}</span>
                            </div>
                        </div>

                        <div class="color-selector-row" *ngIf="default_colors.styles.selected.normal.none.strokeStyle">
                            <div> 
                                <span>strokeStyle:</span>
                            </div>
                            <div>
                                <span class="color-icon me-2" [ngStyle]="{'background-color': default_colors.styles.selected.normal.none.strokeStyle}"></span>
                                <span>{{default_colors.styles.selected.normal.none.strokeStyle}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="color-selector-col">
                        <div class="color-selector-row" *ngIf="default_colors.styles.selected.normal.none['fill-opacity']">
                            <div>    
                                <span>fill-opacity:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.selected.normal.none['fill-opacity']}}</span>
                            </div>
                        </div>
                        <div class="color-selector-row" *ngIf="default_colors.styles.selected.normal.none['stroke-opacity']">
                            <div>
                                <span>stroke-opacity:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.selected.normal.none['stroke-opacity']}}</span>
                            </div>
                        </div>
                        <div class="color-selector-row" *ngIf="default_colors.styles.selected.normal.none.lineWidth">
                            <div>
                                <span>lineWidth:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.selected.normal.none.lineWidth}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class='color-selector-mode' *ngIf="default_colors.styles.selected && default_colors.styles.selected.hover">
                <div class="color-selector-subtitle">
                    <span>SELECTED > HOVER</span>
                </div>
                <div class="color-select-body">
                    <div class="color-selector-col">
                        <div class="color-selector-row" *ngIf="default_colors.styles.selected.hover.none.fillStyle">
                            <div>
                                <span>fillStyle:</span>
                            </div>
                            <div>
                                <span class="color-icon me-2" [ngStyle]="{'background-color': default_colors.styles.selected.hover.none.fillStyle}"></span>
                                <span>{{default_colors.styles.selected.hover.none.fillStyle}}</span>
                            </div>
                        </div>

                        <div class="color-selector-row" *ngIf="default_colors.styles.selected.hover.none.strokeStyle">
                            <div> 
                                <span>strokeStyle:</span>
                            </div>
                            <div>
                                <span class="color-icon me-2" [ngStyle]="{'background-color': default_colors.styles.selected.hover.none.strokeStyle}"></span>
                                <span>{{default_colors.styles.selected.hover.none.strokeStyle}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="color-selector-col">
                        <div class="color-selector-row" *ngIf="default_colors.styles.selected.hover.none['fill-opacity']">
                            <div>    
                                <span>fill-opacity:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.selected.hover.none['fill-opacity']}}</span>
                            </div>
                        </div>
                        <div class="color-selector-row" *ngIf="default_colors.styles.selected.hover.none['stroke-opacity']">
                            <div>
                                <span>stroke-opacity:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.selected.hover.none['stroke-opacity']}}</span>
                            </div>
                        </div>
                        <div class="color-selector-row" *ngIf="default_colors.styles.selected.hover.none.lineWidth">
                            <div>
                                <span>lineWidth:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.selected.hover.none.lineWidth}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class='color-selector-mode' *ngIf="default_colors.styles.unavailable && default_colors.styles.unavailable.normal.none">
                <div class="color-selector-subtitle">
                    <span>UNAVAILABLE > NORMAL</span>
                </div>
                <div class="color-select-body">
                    <div class="color-selector-col">
                        <div class="color-selector-row" *ngIf="default_colors.styles.unavailable.normal.none.fillStyle">
                            <div>
                                <span>fillStyle:</span>
                            </div>
                            <div>
                                <span class="color-icon me-2" [ngStyle]="{'background-color': default_colors.styles.unavailable.normal.none.fillStyle}"></span>
                                <span>{{default_colors.styles.unavailable.normal.none.fillStyle}}</span>
                            </div>
                        </div>
                        <div class="color-selector-row" *ngIf="default_colors.styles.unavailable.normal.none['fill-opacity']">
                            <div>    
                                <span>fill-opacity:</span>
                            </div>
                            <div>
                                <span class="single-value">{{default_colors.styles.unavailable.normal.none['fill-opacity']}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</div>

<!-- <div class="color-apply-container">
    <button class="btn-secondary-action" (click)="applyDefaultStyles()">Aplicar</button>
</div> -->